/*
 * 首页分类切换商品区（sections/home-product-tabs.liquid）。
 * - WAI-ARIA tablist：点击 / ←→ / Home / End 切换（自动激活），roving tabindex
 * - 切换：旧面板 hidden，新面板滚回开头、卡片依次淡入（CSS .is-entering），面板区高度先锁住再放开，页面不跳
 * - 悬停 / 聚焦标签时把该面板的懒加载图改成 eager，点下去时图片多半已经到了
 * - 桌面箭头按“一屏的可见宽度”翻页，到头/到尾自动置灰；放得下时整组箭头隐藏
 * - 桌面鼠标可以按住直接拖（pointer:fine 且一排放不下时）。移动超过 6px 才算拖，拖过的那一下 click 被吞掉，
 *   不会误进商品页；没拖动的普通点击、键盘、触屏手指滑都保持原生行为。松手后平滑吸到最近一张
 * Theme Editor 里选中某个 tab block 时切到它（shopify:block:select）。
 */
(function () {
  function initTabs(root) {
    if (!root || root.dataset.hptReady) return;
    root.dataset.hptReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hpt-tab]'));
    var panelsWrap = root.querySelector('[data-hpt-panels]');
    var arrows = root.querySelector('[data-hpt-arrows]');
    var prev = root.querySelector('[data-hpt-prev]');
    var next = root.querySelector('[data-hpt-next]');
    if (!tabs.length || !panelsWrap) return;

    function panelFor(tab) {
      return document.getElementById(tab.getAttribute('aria-controls'));
    }

    function activeTab() {
      return tabs.find(function (tab) { return tab.getAttribute('aria-selected') === 'true'; }) || tabs[0];
    }

    function activeTrack() {
      var panel = panelFor(activeTab());
      return panel && panel.querySelector('[data-hpt-track]');
    }

    function prefetch(tab) {
      var panel = panelFor(tab);
      if (!panel || panel.dataset.hptPrefetched) return;
      panel.dataset.hptPrefetched = 'true';
      panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.setAttribute('loading', 'eager');
      });
    }

    var finePointer = window.matchMedia('(pointer: fine)');

    function refreshDraggable() {
      root.querySelectorAll('[data-hpt-track]').forEach(function (track) {
        track.classList.toggle('is-draggable', finePointer.matches && track.scrollWidth - track.clientWidth > 1);
      });
    }

    function nearestStop(track) {
      var items = Array.prototype.slice.call(track.children);
      var max = track.scrollWidth - track.clientWidth;
      var best = track.scrollLeft;
      var bestDistance = Infinity;
      items.forEach(function (item) {
        var left = Math.min(item.offsetLeft - track.firstElementChild.offsetLeft, max);
        var distance = Math.abs(left - track.scrollLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = left;
        }
      });
      return best;
    }

    function enableDrag(track) {
      var pointerId = null;
      var startX = 0;
      var startLeft = 0;
      var moved = false;
      var suppressClick = false;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !track.classList.contains('is-draggable')) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startLeft = track.scrollLeft;
        moved = false;
        // 达到拖动阈值前不 capture（保留商品链接点击），但在轨道外松手也必须清理候选状态。
        window.addEventListener('pointerup', end);
        window.addEventListener('pointercancel', end);
        window.addEventListener('blur', cancelDrag);
      });

      track.addEventListener('pointermove', function (event) {
        if (pointerId === null || event.pointerId !== pointerId) return;
        if (event.buttons === 0) {
          end(event);
          return;
        }
        var dx = event.clientX - startX;
        if (!moved) {
          if (Math.abs(dx) < 6) return;
          moved = true;
          track.classList.add('is-dragging');
          if (track.setPointerCapture) track.setPointerCapture(pointerId);
        }
        event.preventDefault();
        track.scrollLeft = startLeft - dx;
      });

      function end(event) {
        if (pointerId === null || (event && event.pointerId !== pointerId)) return;
        pointerId = null;
        window.removeEventListener('pointerup', end);
        window.removeEventListener('pointercancel', end);
        window.removeEventListener('blur', cancelDrag);
        if (!moved) return;
        // 紧跟着的 click（同一次按压）要吞掉；下一个任务再放开
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 0);
        track.classList.remove('is-dragging');
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: nearestStop(track), behavior: reduce ? 'auto' : 'smooth' });
      }

      function cancelDrag() { end(); }

      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('lostpointercapture', end);
      track.addEventListener('click', function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
      // 链接 / 图片自带的原生拖拽（拖出一个半透明缩略图）会抢走鼠标拖动
      track.addEventListener('dragstart', function (event) {
        if (track.classList.contains('is-draggable')) event.preventDefault();
      });
    }

    function updateArrows() {
      refreshDraggable();
      if (!arrows) return;
      var track = activeTrack();
      // 1px 容差：缩放 / 小数宽度下 scrollWidth 会比 clientWidth 多出零点几
      var overflow = track && track.scrollWidth - track.clientWidth > 1;
      arrows.hidden = !overflow;
      if (!overflow) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    function select(tab, options) {
      options = options || {};
      var current = activeTab();
      if (tab === current) {
        if (options.focus) tab.focus();
        return;
      }
      var oldPanel = panelFor(current);
      var newPanel = panelFor(tab);
      if (!newPanel) return;

      // 两个面板高度通常一样，但商品数少 / 标题多一行时会不同：先锁住当前高度，换完再放开，避免下面的内容上下跳
      var lockHeight = panelsWrap.offsetHeight;
      panelsWrap.style.minHeight = lockHeight + 'px';

      tabs.forEach(function (item) {
        var selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });

      if (oldPanel) {
        oldPanel.hidden = true;
        oldPanel.classList.remove('is-entering');
      }
      newPanel.hidden = false;
      var track = newPanel.querySelector('[data-hpt-track]');
      if (track) track.scrollLeft = 0;

      newPanel.classList.remove('is-entering');
      // 强制回流，让同一个面板第二次进入时动画能重播
      void newPanel.offsetWidth;
      newPanel.classList.add('is-entering');

      if (options.focus) tab.focus();
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });

      requestAnimationFrame(function () {
        panelsWrap.style.minHeight = '';
        updateArrows();
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        select(tab);
      });
      tab.addEventListener('pointerenter', function () { prefetch(tab); });
      tab.addEventListener('focus', function () { prefetch(tab); });
      tab.addEventListener('keydown', function (event) {
        var target = null;
        if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') target = tabs[(index - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') target = tabs[0];
        else if (event.key === 'End') target = tabs[tabs.length - 1];
        if (!target) return;
        event.preventDefault();
        select(target, { focus: true });
      });
    });

    function page(direction) {
      var track = activeTrack();
      if (!track) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * track.clientWidth * 0.95, behavior: reduce ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    root.querySelectorAll('[data-hpt-track]').forEach(enableDrag);
    if (finePointer.addEventListener) finePointer.addEventListener('change', refreshDraggable);

    root.querySelectorAll('[data-hpt-track]').forEach(function (track) {
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateArrows);
      }, { passive: true });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateArrows).observe(panelsWrap);
    } else {
      window.addEventListener('resize', updateArrows);
    }
    updateArrows();

    root.addEventListener('animationend', function (event) {
      var panel = event.target.closest && event.target.closest('.hpt__panel');
      if (panel && event.target.matches('.hpt__item:last-child')) panel.classList.remove('is-entering');
    });

    root.hptSelect = function (blockTab) { select(blockTab); };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hpt]').forEach(initTabs);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.closest && event.target.closest('[data-hpt-tab]');
    var root = tab && tab.closest('[data-hpt]');
    if (root && root.hptSelect) root.hptSelect(tab);
  });
})();
